import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password field with built-in show/hide toggle.
 * Use exactly like a styled input. Pass `iconLeft` (a Lucide icon element)
 * to display an icon on the left side (same look as other auth inputs).
 */
export default function PasswordInput({ iconLeft = null, ...inputProps }) {
    const [visible, setVisible] = useState(false);
    return (
        <div className="relative" dir="ltr">
            {iconLeft && (
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400 pointer-events-none">
                    {iconLeft}
                </span>
            )}
            <input
                {...inputProps}
                dir="ltr"
                type={visible ? "text" : "password"}
                className={`${inputProps.className || "input"} ${iconLeft ? "pl-10" : ""} pr-11 text-left`}
                style={{ textAlign: "left", ...inputProps.style }}
            />
            <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                aria-label={visible ? "Nascondi password" : "Mostra password"}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-stone-400 hover:text-stone-700 hover:bg-bone-2 transition-colors z-10"
                tabIndex={-1}
                data-testid={`${inputProps["data-testid"] || "password"}-toggle`}
            >
                {visible ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </div>
    );
}
